import Api from "../axios";

export const getLateComing = async (employeeId) => {
  return await Api.get(`/late_coming?employee_id=${employeeId}`);
};